import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditLevelLayer from "../components/EditLevelLayer.jsx";


const CourseCategoryEdit = () => {
  return (
    <>


        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Level  </h5><Breadcrumb title="Add Level" /></div>


        {/* UsersListLayer */}
        <EditLevelLayer />


    </>
  );
};

export default CourseCategoryEdit; 